import REQUEST from './Request';

export const getBrokers = async () => {
  return await REQUEST({
    method: 'GET',
    url: 'Broker/current',
  });
};

